export const UPDATE_DATA_RETENTION_POLICY = 'UPDATE_DATA_RETENTION_POLICY';
export const UPDATE_DATA_RETENTION_POLICY_SUCCESS = 'UPDATE_DATA_RETENTION_POLICY_SUCCESS';
export const UPDATE_DATA_RETENTION_POLICY_ERROR = 'UPDATE_DATA_RETENTION_POLICY_ERROR';
